import React from 'react';

import CarComponent from './car/Car.component'
import FichasComponent from './car/Fichas.component'
import Gallery from './../components/gallery/GalleryCompontn'
import Videos from './gallery/VideosComponent'
import FullGallery from './gallery/FullGalleryComponent'
import FullVideo from './gallery/FullVideosComponent'
import Viewer360 from './viewer360.component'
import Car360View from './car/Car360View'

import svg_loading from "../UI/oval.svg";

import VehiculosData from './../json/vehiculos.json' 
import Fichas from './../utils/import.fichas'

import Icons from './../utils/import.icons'
import {ContextLoader}  from './../utils/import.frames'
import ico180 from './../UI/interface/icons/180.svg'
import handIco from './../UI/interface/icons/Hand.png'

interface State {
    carSelected?: boolean
    currentCar?: any
    fichaSelected?: boolean
    selectedCar?: string,
    links?: any,
    initFramePOI?: any,
    isPreTransition?: any,
    is180?: boolean,
    gallerySelected?: boolean,
    currentGallery?: any,
    Images?: any,
    openedGallery?: boolean,
    currentImage?: any,
    currentImageIndex?: any,
    currentImageName?: any,
    openedVideo?: boolean,
    currentVideo?: any,
    currentVideoIndex?: any,
    currentVideoName?: any,
    openInterior?: boolean,
    Interior?: any,
    videoCarSelected: any,
    disappear180: boolean,
    isFichas: boolean,
    isGaleria: boolean,
    isInterior: boolean,
    loading: boolean,
    currentIcon: String,
    isvista180: boolean
}

interface Props {
    
}

interface Info {
    nombre?: keyof typeof Fichas
    Fichas?: any
    index?: string
    Icons?: any
    payload?: any
    info?: any
    ContextLoader?: any
    car?: any,
    
}

class Catalogo extends React.Component<Props, State> {

    constructor(props: Props){
        super(props);
        this.state = {
            carSelected: false,
            currentCar: [],
            fichaSelected: false,
            selectedCar: '',
            links: {},
            initFramePOI: 0,
            isPreTransition: false,
            is180: false,
            gallerySelected: false,
            currentGallery: [],
            Images: {},
            openedGallery: false,
            currentImage: "",
            currentImageIndex: -1,
            currentImageName: "",
            openedVideo: false,
            currentVideo: "",
            currentVideoIndex: -1,
            currentVideoName: "",
            videoCarSelected: {},
            openInterior: false,
            Interior: [],
            disappear180: false,
            isFichas: false,
            isGaleria: false,
            isInterior: false,
            loading: false,
            currentIcon: "",
            isvista180: false,
        }
    }

    

    handleDisplay = (payload: any) => (
        this.setState({
            carSelected: true,
            currentCar: payload
        }),
        this.handleLoadCar(payload.Nombre)
    )

    handleLoadCar = (payload: any) => {
        if(ContextLoader.hasOwnProperty(payload)){
            const car: Info = {ContextLoader}
            const ls = car.ContextLoader[payload]()
            this.setState({
                links: ls,
                is180: ls.length === 36
            })
        }
    }
        
    handleGetIconNombre = (payload: any) => {
        const mapa: Info = {Icons}
        
        return <img src={mapa.Icons[payload]} className = "img-nombre" alt=''></img>
    }

    handleGetBackgroundImage = (payload: any) => {
        const mapa: Info = {ContextLoader}
        return <img className="background-image" src={mapa.ContextLoader['backgrounds']()[payload.Index]}></img>
    }

    handleCountRows = () => {
        var rows = []
        var i;
        var j = 0;
        var k = 3;
        for (i = 0; i < Object.keys(VehiculosData.Vehiculos).length / 3; i++){
            rows.push(<div key={i} className = "row-container">
                {
                VehiculosData.Vehiculos.slice(j,k).map((vehiculo: any, index: number) =>
                        <button key = {index} className = "car-container" onClick = {() => this.handleDisplay(vehiculo)}>
                            <img src = {ContextLoader["intro"]()[vehiculo.Index]} className = "car-bg" alt=''></img>
                            <div>
                                {
                                    this.handleGetIconNombre(vehiculo.Nombre)
                                }
                            </div>
                        </button>
                )
                }
            </div>)
            j += 3
            k += 3
        }


        return rows
    }

    handleBackBtn = () => (
        this.setState({
            carSelected: false,
            currentCar: [],
            fichaSelected: false,
            selectedCar: '',
            gallerySelected: false,
            currentGallery: [],
            disappear180: false,
            isFichas: false,
            isGaleria: false,
            isInterior: false,
            isvista180: false,
        })
    )

    handleFichasBtn = (payload: any) => (
        this.setState({
            fichaSelected: true,
            selectedCar: payload.Nombre,
            isFichas: true,
            isGaleria: false,
            isInterior: false,
            isvista180: false,
            disappear180: false
        })
    )

    handleGalleryBtn = (payload: any) => (
        this.setState({
            fichaSelected: false,
            gallerySelected: true,
            currentGallery: payload.Gallery,
            isFichas: false,
            isGaleria: true,
            isInterior: false,
            isvista180: false,
            disappear180: false
        })
    ) 

    handleGalleryimgs = () => {
        if(ContextLoader.hasOwnProperty("Galeria "+this.state.currentCar.Nombre)){
            return (
                <React.Fragment>
                    <div className = "imagenes-titles">Imágenes</div>
                    <Gallery 
                        payload = {"Galeria "+this.state.currentCar.Nombre}
                        handleImageClick = {this.handleOpenGallery}
                        
                    />
                </React.Fragment>
            )
        }
        
    }

    handleGalleryVids = () => {
        if(ContextLoader.hasOwnProperty("Videos " + this.state.currentCar.Nombre)){
            return (
                <React.Fragment>
                    <div className = "imagenes-titles">Videos</div>
                    <Videos
                        payload = {"Videos "+this.state.currentCar.Nombre}
                        handleVideoClick = {this.handleOpenVideo}
                        information = {this.state.currentCar}
                    />
                </React.Fragment>
            )
        }
    }

    handleOpenVideo = (payload: any, index: number, nombre: string, information: any) => {
        this.setState({
            openedVideo: true,
            currentVideo: payload,
            currentVideoIndex: index,
            currentVideoName: nombre,
            gallerySelected: false,
            videoCarSelected: information,
            isvista180: false,
            disappear180: false
        })
    }

    handleOpenGallery = (payload: any, index: number, nombre: string) => {
        this.setState({
            openedGallery: true,
            currentImage: payload,
            currentImageIndex: index,
            currentImageName: nombre,
            gallerySelected: false,
            isvista180: false,
            disappear180: false
        })
    }

    handleCloseGallery = () => (
        this.setState({
            openedGallery: false,
            openedVideo: false,
            gallerySelected: true,
            isvista180: false,
            disappear180: false
        })
    )

    handleOpenInterior360 = (payload: any) => {
        this.setState({
            openInterior: true,
            Interior: ContextLoader["Interior "+payload.Nombre](),
            isFichas: false,
            isGaleria: false,
            isInterior: true,
            loading: true,
            isvista180: false,
            disappear180: false
        })
    }

    handleClose360 = () => {
        this.setState({
            openInterior: false,
            Interior: [],
            isFichas: false,
            isGaleria: false,
            isInterior: false,
            gallerySelected: false,
            openedGallery: false,
            fichaSelected: false,
            isvista180: false,
            disappear180: false
        })
    }

    handleGet180name = (payload: any) => {
        const mapa: Info = {Icons}
        console.log(payload)
        return <img src={mapa.Icons[payload.Nombre + " BLACK"]} className="car-name-180" alt=''></img>
    }

    handleVista180 = () => {
        this.setState({
            isvista180: true
        })
    }

    handleDisappear180 = () => {
        this.setState({
            disappear180: true
        })
    }

    handleAppear180 = () => {
        this.setState({
            disappear180: false
        })
    }

    handleCloseVista180 = () => {
        this.setState({
            isvista180: false,
            disappear180: false
        })
    }

    on360Ready = () => {
        this.setState({
          loading: false,
        });
      };

    render() {
        return(
            <React.Fragment>
                <div className = "catalogo-page">
                {
                    this.state.carSelected ? 
                    <React.Fragment>
                        <CarComponent 
                        CurrentCar = {this.state.currentCar}
                        handleBackBtn = {this.handleBackBtn}
                        handleFichasBtn = {this.handleFichasBtn}
                        handleGalleryBtn = {this.handleGalleryBtn}
                        handleInteriorBtn = {this.handleOpenInterior360}
                        isFichas = {this.state.isFichas}
                        isGaleria = {this.state.isGaleria}
                        isInterior = {this.state.isInterior}
                        Icon = {this.state.currentIcon}
                        is180 = {this.state.isvista180}
                        handleVista180 = {this.handleVista180}
                        />
                        {
                            this.state.fichaSelected ? 
                            <FichasComponent
                            CurrentCar = {this.state.selectedCar}
                            />
                            :
                                this.state.gallerySelected ?
                                <div className = "right-container">
                                    <div className = "gallery">
                                        {this.handleGalleryVids()}
                                        {this.handleGalleryimgs()}
                                    </div>
                                    <div className = "nota-legal">
                                        <p>*Imágenes de referencia. Características del vehículo deberán verificarse personalmente en la vitrina.</p>
                                    </div>
                                </div>
                                :
                                    this.state.openedGallery ?
                                    <div>
                                        <FullGallery 
                                            image = {this.state.currentImage}
                                            index = {this.state.currentImageIndex}
                                            nombre = {this.state.currentImageName}
                                            handleClose = {this.handleCloseGallery}
                                        ></FullGallery>
                                    </div>
                                    :
                                    <div className = "right-container">
                                        {
                                            this.handleGetBackgroundImage(this.state.currentCar)
                                        }
                                        <div className = "nota-legal spin-nota">
                                            <p>*Imagen de referencia. Características del vehículo deberán verificarse personalmente en la vitrina.</p>
                                        </div>
                                    </div>
                                    
                        }
                        {
                            this.state.openedVideo ? 
                            <div>
                                <FullVideo 
                                    video = {this.state.currentVideo}
                                    index = {this.state.currentVideoIndex}
                                    nombre = {this.state.currentVideoName}
                                    car = {this.state.videoCarSelected}
                                    handleClose = {this.handleCloseGallery}
                                >
                                </FullVideo>
                            </div>:<></>
                        }
                        <div>
                            {
                                this.state.openInterior ? 
                                <Viewer360
                                    path={ window.innerWidth > 825 ? this.state.Interior[0] : this.state.Interior[1] }
                                    name = {this.state.currentCar}
                                    handleOutBtn = {this.handleClose360}
                                    onReady={this.on360Ready}
                                />:<></>
                            }
                        </div>
                        <div className="responsive-container"></div>
                    </React.Fragment>
                    :
                    this.handleCountRows()
                }
                
            </div>
            
            {
                this.state.loading ? 
                <div className="canvas-loading">
                    <img className='loader-circle' src={svg_loading} alt=''></img>
                </div>:
                <></>
            }
            {
                this.state.isvista180 ?
                <div className="full-180-container" >
                    <div className = "car-container-180" onMouseDown={this.handleDisappear180} onMouseUp={this.handleAppear180} onTouchStart={this.handleDisappear180} onTouchEnd={this.handleAppear180}>
                        <button className = "close-360" onClick = {() => this.handleCloseVista180()}><img src={Icons["out"]} alt=''></img></button>
                        <img src={ico180} className={this.state.disappear180 ? "ico180 disappear-180":"ico180"} alt=''></img>
                        <img src={handIco} className={this.state.disappear180 ? "hand disappear-hand":"hand"} alt=''></img>
                        <Car360View
                            car = {this.state.currentCar}
                        />
                    </div>
                    {
                        this.handleGet180name(this.state.currentCar)
                    }
                    <div className = "nota-legal spin-nota">
                        <p>*Imagen de referencia. Características del vehículo deberán verificarse personalmente en la vitrina.</p>
                    </div>
                </div>:
                <></>
            }
            <div className="responsive-portrait-layer">
                <div className="layer">
                    <span className="layer-text">MEJORA TU EXPERIENCIA</span>
                    <div className="layer-imgs">
                        <img className = "layer-img" src={Icons["rotate"]} alt=''></img>
                        <img className = "layer-img" src={Icons["phone"]} alt=''></img>
                    </div>
                    
                </div>
            </div>
            </React.Fragment>
        )
    }
}

export default Catalogo